import React, { useState, useEffect } from 'react';
import { get } from './axios_call';
import Catalogue from '../elements/lightbox/Catalogue';

export default (title) => {
  const [catalogues, setCatalogues] = useState([]);
  useEffect(() => {
    let sourceOuter;
    get('catalogues', true).then(([res, source]) => {
      sourceOuter = source;
      setCatalogues(
        res.data.map((catalogue) => (
          <Catalogue
            title={catalogue.title}
            id={catalogue.id}
            images={catalogue.images}
            key={catalogue.id}
            hash={catalogue.hash}
          />
        )),
      );
    });
    return () => {
      sourceOuter.cancel();
    };
  }, [title]);
  return catalogues;
};
